/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `DI` - DI
 *   * `TI` - TI
 *   * `ZPS` - ZPS
 * ```
 */
export const DtmDataTypeEnum = { DI: 'DI', TI: 'TI', ZPS: 'ZPS' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DtmDataTypeEnum = ValuesOf<typeof DtmDataTypeEnum>;

export type DtmDataTypeEnumRequest = DtmDataTypeEnum;
export type DtmDataTypeEnumResponse = DtmDataTypeEnum;
